<template lang="pug" src="./drivers.pug"></template>
<style lang="scss" src="./drivers.scss"></style>

<script>
import { mapState, mapGetters } from 'vuex';
import { copyToClipboard } from '@/utils/helpers';
import request from '@/utils/request';

import config from '@/config.json';

export default {
    data: () => ({
        startDateModal: false,
        endDateModal: false,
        requestProcessing: false,
        disabledModal: false,
        reRegistrationModal: false,
        reRegistration: null,
        newKarma: 0
    }),
    computed: {
        ...mapGetters(['roleName', 'userBrandId', 'operator']),
        ...mapState({
            items: state => state.users.drivers.items,
            pagination: state => state.users.drivers.pagination,
            brands: state => state.data.brands,
            commissions: state => state.data.driverCommissions
        }),
        headers() {
            const properties = [];
            const additionalProperties = [];

            if (this.canEdit) {
                properties.push('actions');
            }

            if (!this.userBrandId) {
                properties.push('brandId');
            }

            if (this.showUnfullTable) {
                const updatedAt = this.filterBy == 'removed' ? 'updatedAt' : null;
                const commission = this.roleName === 'manager' ? null : 'commission';

                additionalProperties.push('address', 'createdAt', updatedAt, commission , 'minBalance');
            }

            return [
                'callSign',
                ...properties,
                'driverStatus', 'fullName', 'shortCarInfo', 'phoneNumber',
                ...additionalProperties.filter(it => !!it), 'karma',
                'imei', 'email', 'additionalPhoneNumbers',
                'additionalAdresses', 'pledge'
            ].map(it => ({
                text: this.$vuetify.lang.t(`$vuetify.pages.Users.table.${it}`),
                value: it,
                sortable: false,
                align: 'center'
            }));
        },
        brandsSelect() {
            return [{
                id: null,
                title: this.$vuetify.lang.t(`$vuetify.pages.Users.all`)
            }].concat(this.brands);
        },
        query: {
            get() {
                return this.$store.state.users.drivers.filters.query;
            },
            set(val) {
                return this.$store.commit('users/SET_DRIVERS_QUERY', val);
            }
        },
        filterBy: {
            get() {
                return this.$store.state.users.drivers.filters.filterBy;
            },
            set(val) {
                return this.$store.commit('users/SET_DRIVERS_FILTER_BY', val);
            }
        },
        startDate: {
            get() {
                return this.$store.state.users.drivers.filters.startDate;
            },
            set(val) {
                return this.$store.commit('users/SET_DRIVERS_START_DATE', val);
            }
        },
        endDate: {
            get() {
                return this.$store.state.users.drivers.filters.endDate;
            },
            set(val) {
                return this.$store.commit('users/SET_DRIVERS_END_DATE', val);
            }
        },
        brandId: {
            get() {
                return this.$store.state.users.drivers.filters.brandId;
            },
            set(val) {
                this.$store.commit('users/SET_DRIVERS_BRAND_ID', val);
                this.commissionId = null;

                const payload = {
                    showActive: true
                };

                if (val) {
                    payload.brandIds = JSON.stringify([val]);
                }

                this.$store.dispatch('data/getDriverCommissions', payload);
            }
        },
        commissionId: {
            get() {
                return this.$store.state.users.drivers.filters.commissionId;
            },
            set(val) {
                this.$store.commit('users/SET_DRIVERS_COMMISSION_ID', val);
            }
        },
        driverStatuses() {
            const statuses = config.driverStatuses;

            if (this.showRemovedDrivers) {
                statuses.push('removed');
            }

            return statuses;
        },

        isMainRolePlus() {
            return ['accountant', 'manager', 'admin', 'boss'].includes(this.roleName);
        },

        isMainRole() {
            return ['manager', 'admin', 'boss'].includes(this.roleName);
        },

        isUnfullRole() {
            return ['operator'].includes(this.roleName);
        },

        canEdit: function() {
            return this.isMainRolePlus;
        },

        showDateFilters: function() {
            return !this.isUnfullRole;
        },

        showBrandsFilter() {
            return ['operator', 'intern', 'manager'].includes(this.roleName) ? !this.userBrandId : true;
        },

        showCommissionFilter() {
            return ['admin', 'manager', 'boss'].includes(this.roleName);
        },

        showUnfullTable: function() {
            return (!this.isUnfullRole || (this.isUnfullRole && this.filterBy == 'removed'));
        },

        showRemovedDrivers: function() {
            return this.isMainRolePlus;
        },

        canAddDrivers: function() {
            return ['admin'].includes(this.roleName) ||
                ['boss'].includes(this.roleName) && this.operator.canEditDrivers;
        },

        canEditKarma() {
            return ['admin'].includes(this.roleName);
        }
    },
    created() {
        this.filterBy = config.driverStatuses[0];
        this.brandId = this.userBrandId || null;

        this.$store.dispatch('data/getBrands');
        this.loadItems();
    },
    beforeDestroy() {
        this.$store.commit('users/RESET_DRIVERS_FILTERS');
    },
    methods: {
        copyToClipboard,
        loadItems(page = 1) {
            if (this.requestProcessing) return;

            this.requestProcessing = true;

            this.$store.dispatch('users/getDrivers', Object.assign({}, {
                q: this.query,
                filterBy: this.filterBy,
                startDate: this.startDate,
                endDate: this.endDate,
                brandId: this.brandId,
                commissionId: this.commissionId,
                page
            })).then(() => {
                this.$nextTick(() => this.requestProcessing = false);
            });
        },
        onPageChange(page) {
            if (page !== this.pagination.page) {
                this.loadItems(page);
            }
        },
        changeEndDate() {
            this.endDateModal = false;
            this.loadItems();
        },
        changeStartDate() {
            this.startDateModal = false;
            this.loadItems();
        },
        cancelDisabled() {
            this.disabledModal = false;
            this.reRegistration = null;
        },
        async blockDrivers() {
            await request({
                method: 'post',
                url: `/drivers/list/disable`,
                data: { reRegistration: this.reRegistration }
            }).then(res => {
                if (res.status == 204) {
                    this.$store.dispatch('alert/addMessage', {
                        type: 'success',
                        message: 'success'
                    });

                    this.loadItems();

                    this.disabledModal = false;
                    this.reRegistration = null;
                }
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    this.$store.dispatch('alert/addMessage', {
                        message: error.response.data.error
                    });
                }
            });
        },
        openKarmaDialog(karma) {
            this.newKarma = karma;
        },
        async updateKarma(driverId) {
            await request({
                method: 'patch',
                url: `/drivers/${driverId}/karma`,
                data: { karma: this.newKarma || 0 }
            }).then(res => {
                if (res.status == 204) {
                    this.$store.dispatch('alert/addMessage', {
                        type: 'success',
                        message: 'success'
                    });

                    const index = this.items.findIndex(it => it.id == driverId);

                    if (index != -1) {
                        this.items[index].karma = this.newKarma;
                    }
                }
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    this.$store.dispatch('alert/addMessage', {
                        message: error.response.data.error
                    });
                }
            });
        }
    }
};
</script>
